import ItemsV3Adapter from '@square/dashboard-items-data/adapters/items-v3-base';
import { CATALOG_SERVICE_QUERY_TYPES } from '@square/dashboard-data/models/catalog/catalog-service-constants';
import Discount from '@square/dashboard-items-data/models/discount';
export default ItemsV3Adapter.extend({
  // a comp discount is actually just a DISCOUNT with a COMP application method on the server
  async findAll(store, type) {
    const response = await this.query(store, type, {
      fetchAll: true,
      attributeQueries: [{
        type: CATALOG_SERVICE_QUERY_TYPES.RANGE,
        attribute: 'application_method',
        begin: Discount.ApplicationMethod.serialize(Discount.ApplicationMethod.COMP),
        end: Discount.ApplicationMethod.serialize(Discount.ApplicationMethod.COMP)
      }]
    });
    this.set('hasFetchedAll', true);
    return response;
  }
});